import * as React from 'react';
import $ from "jquery";
import Common from '../utilities/common';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, TextField, Typography } from '@mui/material';
import { ComunidadAutonoma } from './ComunidadAutonoma';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import ErrorDialog from '../utilities/ErrorDialog';

export interface IComunidadAutonomaEditProps {
    open: boolean;
    onClose?: Function;
    onSave?: Function;
    selectedItem: ComunidadAutonoma | undefined;
}

export interface IComunidadAutonomaEditState {
    open: boolean;
    hasErrors: boolean;
    errorMessage: string;
    openErroDialog: boolean;
}

export default class ComunidadAutonomaEdit extends React.Component<IComunidadAutonomaEditProps, IComunidadAutonomaEditState> {
    _comunidadAutonoma: ComunidadAutonoma = new ComunidadAutonoma();
    _id: number = -1;
    
    public constructor(props: IComunidadAutonomaEditProps) {
        super(props);

        this.state = {
            open: false,
            hasErrors: false,
            errorMessage: '',
            openErroDialog: false
        }
    }

    componentWillReceiveProps(nextProps: Readonly<IComunidadAutonomaEditProps>, nextContext: any): void {
        if(nextProps.selectedItem != null) {
            this._comunidadAutonoma = nextProps.selectedItem;
        }

        this.setState({
            open: nextProps.open
        });
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                <Dialog open={this.state.open} fullWidth>
                    <DialogTitle>
                        Modificar comunidad autónoma
                    </DialogTitle>
                    <DialogContent>
                        {
                            this.state.hasErrors && (
                                <Alert severity="error" style={{marginBottom: '10px'}}>
                                    {
                                        this.state.errorMessage
                                    }
                                </Alert>
                            )
                        }
                        <Box>
                            <FormControl fullWidth>
                                <TextField required variant='standard' label='Nombre' defaultValue={this._comunidadAutonoma.name} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    console.log(event.target.value);
                                    if(event.target.value == '') {
                                        this.setState(
                                            {
                                                hasErrors: true,
                                                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
                                            }
                                        );
                                    }
                                    else {
                                        this.setState(
                                            {
                                                hasErrors: false,
                                                errorMessage: ''
                                            }
                                        );
                                        this._comunidadAutonoma.name = event.target.value;
                                    }
                                }}></TextField>
                            </FormControl>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.Update.bind(this)}>OK</Button>
                        <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                    </DialogActions>
                </Dialog>
                <ErrorDialog open={this.state.openErroDialog} onClose={this.Close.bind(this)} />
            </React.Fragment>
        )
    }

    private Close() {
        this.setState(
            {
                open: false,
                openErroDialog: false,
                hasErrors: false,
                errorMessage: ''
            }
        );

        if(this.props.onClose != null) {
            this.props.onClose();
        }
    }

    private Update() {
        if(this._comunidadAutonoma.name == '' || this._comunidadAutonoma.name == null) {
            this.setState({
                hasErrors: true,
                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
            })
            return;
        }

        let url = `${Common.END_POINT}/masters/comunidadesautonomas/${this._comunidadAutonoma.id}/update`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._comunidadAutonoma),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._comunidadAutonoma = new ComunidadAutonoma();
        }).fail((jqXHR, textStatus, errorThrown) => {
            this.setState(
                {
                    open: false,
                    openErroDialog: true
                }
            );
    
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._comunidadAutonoma = new ComunidadAutonoma();
        });
    }
}